import moment from 'moment';

export function tempoValida(hora, diaReferencia) {
  const dia = moment(diaReferencia).isSame(moment(), 'day');
  if (!dia && moment(hora).isValid()) return true;
  else
    return hora instanceof Date && !isNaN(hora) && moment(hora).isSameOrBefore(moment().add(1, 'hour'), 'minute');
}
